import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AccountService } from '../../../../core/services/account.service';
import { UUID } from 'angular2-uuid';
import { flatMap } from 'rxjs/operators';
import { throwError } from 'rxjs';

@Component({
  selector: 'app-accept-invite',
  templateUrl: './accept-invite.component.html',
  styleUrls: ['./accept-invite.component.scss'],
})
export class AcceptInviteComponent implements OnInit {
  guid = UUID.UUID();
  isLoading = true;

  constructor(private accountService: AccountService, private route: ActivatedRoute, private router: Router) { }

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      this.guid = params.Code || params.code;

      if (!this.guid) {
        throw new Error('Code parameter not found');
      }

      this.router.navigate(['/signup-invite'], {
        queryParams: {
          inviteId: this.guid
        }
      });
    });
  }
}
